import { useState, useRef, useCallback } from "react";

export const useInputWidth = () => {
  const [inputWidth, setInputWidth] = useState(0);
  const inputRef = useRef<HTMLElement | null>(null);
  const setInputRef = useCallback((node: HTMLElement | null) => {
    if (node) {
      inputRef.current = node;
      setInputWidth(node.offsetWidth);
    }
  }, []);

  return {
    inputWidth,
    inputRef,
    setInputRef
  };
};
